import React from 'react';
import { useSelector } from 'react-redux';

// TODO: import from @wetransfer/one-launcher repo
import {
  AppLauncher as AppLauncherComponent,
  LauncherButton,
  DEFAULT_APP_IDS,
  AppInfo,
} from '../../vendor/one-launcher-1.0.8';
import '../../vendor/one-launcher-1.0.8/index.css';

import { getPlanTier } from '@wetransfer/transfer/helper/user';
import Analytics from '@wetransfer/transfer/modules/analytics';
import { State } from '@wetransfer/transfer/store/types';

import './AppLauncher.scss';

export const AppLauncherZIndex = 100;

interface Props {
  isLoading: boolean;
}

export const AppLauncher: React.FC<Props> = ({ isLoading }) => {
  const { user } = useSelector((state: State) => ({
    user: state.user,
  }));

  const handleNavigate = React.useCallback(({ id }: AppInfo) => {
    let actionLabel = 'WT';

    if (id === DEFAULT_APP_IDS.Collect) {
      actionLabel = 'Collect';
    } else if (id === DEFAULT_APP_IDS.Paste) {
      actionLabel = 'Paste';
    } else if (id === DEFAULT_APP_IDS.WePresent) {
      actionLabel = 'WePresent';
    }
    Analytics.trackSnowplowEvent({
      category: 'navigation_bar',
      action: 'clickLauncher' + actionLabel,
      label: getPlanTier(user) || 'anonymous',
    });
  }, []);

  const handleOpen = React.useCallback(() => {
    Analytics.trackSnowplowEvent({
      category: 'one_launcher',
      action: 'open_launcher',
    });
  }, []);

  // In the event we are still loading, don't show the logo
  if (isLoading) {
    return null;
  }

  return (
    <AppLauncherComponent
      onNavigate={handleNavigate}
      onOpen={handleOpen}
      currentAppId={DEFAULT_APP_IDS.WeTransfer}
      className="AppLauncher"
      style={{
        zIndex: AppLauncherZIndex,
      }}
    >
      <LauncherButton />
    </AppLauncherComponent>
  );
};
